import React from 'react';
import truncate from 'lodash/truncate';

import PropTypes from 'prop-types';
import { formatMoney } from 'accounting';
import classNames from 'classnames';

import styles from './PreviewProductCard.module.css';

const PreviewProductCard = ({
  brandName,
  name,
  salePrice,
  price,
  percentOff,
  imageUrl,
  style,
  isMobileDevice,
}) => {
  return (
    <div className={styles.container} style={style}>
      <div className={styles.discount}>
        <span>{`${percentOff}%`}</span>
        <span>Off</span>
      </div>
      <div className={styles.imgContainer}>
        <img src={imageUrl} alt="popular product" />
      </div>
      <div className={styles.text}>
        <p>
          {truncate(brandName ? `${brandName} ${name}` : name, {
            length: isMobileDevice ? 35 : 50,
          })}
        </p>
        <div className={styles.price}>
          <h4 className={classNames({ [styles.blur]: !salePrice })}>
            {salePrice ? formatMoney(salePrice) : '$X.XX'}
          </h4>
          {price && <span>{formatMoney(price)}</span>}
        </div>
      </div>
    </div>
  );
};

PreviewProductCard.propTypes = {
  brandName: PropTypes.string,
  name: PropTypes.string.isRequired,
  salePrice: PropTypes.string,
  price: PropTypes.string,
  percentOff: PropTypes.number.isRequired,
  imageUrl: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
  isMobileDevice: PropTypes.bool.isRequired,
};

PreviewProductCard.defaultProps = {
  brandName: '',
  style: {},
  salePrice: '',
  price: '',
};

export default PreviewProductCard;
